import * as Styled from './styles'

export const FooterCopyright = (): JSX.Element => {
  const year = new Date().getFullYear()

  return (
    <Styled.FooterCopyright>
      <div className="content">
        <p>© 1998 - {year} Góes &amp; Nicoladelli Advogados associados</p>
        <p>CNPJ: 03.239.823/0001-62</p>
      </div>
    </Styled.FooterCopyright>
  )
}
